export default "__VITE_ASSET__afbbda46__"